import React from "react";

const IdleTimeout = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00032 13C10.4855 13 12.5002 10.9854 12.5002 8.50017C12.5002 6.01498 10.4855 4.00034 8.00032 4.00034C5.51513 4.00034 3.50049 6.01498 3.50049 8.50017C3.50049 10.9854 5.51513 13 8.00032 13Z"
        stroke="#FFB302"
        strokeWidth="0.980392"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75068 6.75L8 8.50068"
        stroke="#FFB302"
        strokeWidth="0.980392"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 4.50058L4.50058 3"
        stroke="#FFB302"
        strokeWidth="0.980392"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4998 3L13.0003 4.50058"
        stroke="#FFB302"
        strokeWidth="0.980392"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 3.99962L8 3"
        stroke="#FFB302"
        strokeWidth="0.980392"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IdleTimeout;
